import template from '@components/expertise/discovery/discovery.module.scss'
import { IDiscoveryCardsText, IDiscoveryPhaseBenefitsSection } from '../../discovery.state';
import style from './index.module.scss'

interface DiscoveryPhaseBenefitsSectionProps {
    section: IDiscoveryPhaseBenefitsSection;
}

const DiscoveryPhaseBenefitsSectionComponent = ({ section }: DiscoveryPhaseBenefitsSectionProps) => {
    return (
        <section className={`${template.section} ${template.section__block_gray}`}>
            <div className={`${template.container} ${template.container__benefits}`}>
                <div className={template.benefits__block}>
                    <h2 className={template.benefits__title}>
                        {section.title}
                    </h2>
                    <div className={template.benefits__items}>
                        {
                            section.cards.map((item: IDiscoveryCardsText, index: number) => {
                                return (
                                    <div key={index} className={template.benefits__item}>
                                        <div className={template.benefits__item__title}>
                                            {item.title}
                                        </div>
                                        <div className={template.benefits__item__text}>
                                            {item.text}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default DiscoveryPhaseBenefitsSectionComponent;